function getBackendURL() {
    if (process.env.NODE_ENV === 'production') {
        return 'https://test-me-api-xdd35hnbla-uc.a.run.app';
    } else {
        return 'http://localhost:8000'
    }
}

export default getBackendURL;